/* Reya · Mobile dock: always pinned to the bottom, live wishlist + bag counts,
   Bag opens the cart drawer, Search opens the header search. */
(() => {
  const dock = document.querySelector('[data-rr-dock]');
  if (!dock || dock.__rr) return;
  dock.__rr = true;
  document.body.classList.add('rr-has-dock');
  const mq = window.matchMedia('(max-width: 749px)');

  let lastY = window.scrollY;
  let ticking = false;
  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        const nearBottom = window.innerHeight + y >= document.documentElement.scrollHeight - 40;
        dock.classList.remove('is-hidden'); // dock stays pinned while scrolling
        document.body.classList.toggle('rr-dock-hidden', dock.classList.contains('is-hidden'));
        lastY = y;
        ticking = false;
      });
    },
    { passive: true }
  );

  const setBadge = (el, n) => {
    if (!el) return;
    const v = n > 0 ? String(Math.min(n, 99)) : '';
    if (el.textContent === v) return;
    el.textContent = v;
    if (v) {
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    }
  };
  const wishEl = dock.querySelector('[data-rr-dock-wish]');
  const cartEl = dock.querySelector('[data-rr-dock-cart]');
  const syncWish = () => setBadge(wishEl, window.ReyaWishlist ? window.ReyaWishlist.get().length : 0);
  document.addEventListener('rr:wishlist:change', syncWish);
  window.addEventListener('storage', (e) => e.key === 'rr:wishlist' && syncWish());
  syncWish();
  setTimeout(syncWish, 800);

  // Bag count follows the header bubble (Dawn re-renders it after every cart change)
  const bubbleHost = document.getElementById('cart-icon-bubble');
  const syncCart = () => {
    const b = bubbleHost && bubbleHost.querySelector('.cart-count-bubble span[aria-hidden]');
    setBadge(cartEl, b ? parseInt(b.textContent, 10) || 0 : 0);
  };
  if (bubbleHost) new MutationObserver(syncCart).observe(bubbleHost, { childList: true, subtree: true, characterData: true });

  const bag = dock.querySelector('[data-rr-dock-bag]');
  if (bag) {
    bag.addEventListener('click', (e) => {
      const drawer = document.querySelector('cart-drawer');
      if (!mq.matches || !drawer || typeof drawer.open !== 'function') return;
      e.preventDefault();
      e.stopPropagation();
      drawer.open(e.currentTarget);
    });
  }
  const search = dock.querySelector('[data-rr-dock-search]');
  if (search) {
    search.addEventListener('click', (e) => {
      const summary = document.querySelector('.rr-icons details-modal.header__search > details > summary') || document.querySelector('details-modal.header__search > details > summary');
      if (!mq.matches || !summary) return;
      e.preventDefault();
      e.stopPropagation();
      window.scrollTo({ top: 0 });
      setTimeout(() => summary.click(), 0);
      setTimeout(() => {
        const input = document.querySelector('.search-modal input[type="search"], #Search-In-Modal');
        if (input) input.focus();
      }, 250);
    });
  }
})();
